const componentName = 'event'; //TODO: Get it from the packages.json

export function path() {
  let path = ".";
  if(window.orbit) {
    let component = window.orbit.npm.find(e=>e.package==`@startinblox/component-${componentName}`);
    path = `https://cdn.skypack.dev/${component.package}@${component.version}/`;
    if(component.path) {
      path = component.path.replace('/solid-event.js', '')
    }
  }
  return path;
}

export function coreVersion() {
  let coreUrl = "https://cdn.skypack.dev/@startinblox/core";
  if(window.orbit) {
    let core = window.orbit.npm.find(e=>e.package=='@startinblox/core');
    coreUrl += `@${core.version}`;
    if(core.path) {
      coreUrl = core.path;
    }
  }
  return coreUrl;
}

export function setupOrbit(component) {
  if(window.orbit && window.orbit.intl) {
    component.localize = (key) => {
      return window.orbit.intl.t(`${componentName}.${key}`) || component.strings[key] || key;
    }
    component.getRoute = window.orbit.getRoute;
  } else {
    component.getRoute = () => componentName;
  }
}

export function uniq() {
  return Math.random().toString(16).slice(2);
}
